import { useTranslation } from "react-i18next";
import logo96Webp from "../assets/images/logo-96.webp";
import logo128Webp from "../assets/images/logo-128.webp";
import logo192Webp from "../assets/images/logo-192.webp";
import logo256Webp from "../assets/images/logo-256.webp";
import logo96Png from "../assets/images/logo-96.png";
import logo128Png from "../assets/images/logo-128.png";
import logo192Png from "../assets/images/logo-192.png";
import logo256Png from "../assets/images/logo-256.png";

const LOGO_SIZES = {
  sm: {
    webp: logo96Webp,
    png: logo96Png,
    width: 96,
    height: 68,
    srcSetWebp: `${logo96Webp} 96w, ${logo128Webp} 128w`,
    srcSetPng: `${logo96Png} 96w, ${logo128Png} 128w`,
    sizes: "96px",
  },
  md: {
    webp: logo192Webp,
    png: logo192Png,
    width: 192,
    height: 136,
    srcSetWebp: `${logo128Webp} 128w, ${logo192Webp} 192w, ${logo256Webp} 256w`,
    srcSetPng: `${logo128Png} 128w, ${logo192Png} 192w, ${logo256Png} 256w`,
    sizes: "(max-width: 768px) 112px, 184px",
  },
};

export const Logo = ({ className = "", size = "md" }) => {
  const { t } = useTranslation();
  const asset = LOGO_SIZES[size] || LOGO_SIZES.md;

  return (
    <picture>
      <source srcSet={asset.srcSetWebp} sizes={asset.sizes} type="image/webp" />
      <img
        src={asset.png}
        srcSet={asset.srcSetPng}
        sizes={asset.sizes}
        alt={t("common.logoAlt")}
        className={`object-contain object-center mx-auto ${className}`}
        width={asset.width}
        height={asset.height}
        decoding="async"
      />
    </picture>
  );
};
